import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const AnimatedSection = ({ 
  children, 
  className = '', 
  delay = 0, 
  direction = 'up', 
  duration = 0.5,
  threshold = 0.1,
  once = true
}) => {
  const [ref, inView] = useInView({
    threshold: threshold,
    triggerOnce: once
  });

  // Determine animation based on direction
  const getAnimationProps = () => {
    switch(direction) {
      case 'up':
        return { y: 50, opacity: 0 };
      case 'down':
        return { y: -50, opacity: 0 };
      case 'left':
        return { x: -50, opacity: 0 };
      case 'right':
        return { x: 50, opacity: 0 };
      case 'scale':
        return { scale: 0.8, opacity: 0 };
      default:
        return { y: 50, opacity: 0 };
    }
  };

  const variants = {
    hidden: getAnimationProps(),
    visible: { 
      y: 0, 
      x: 0, 
      scale: 1, 
      opacity: 1, 
      transition: {
        duration: duration,
        delay: delay,
        ease: 'easeOut'
      }
    }
  };

  return (
    <motion.div
      ref={ref}
      className={className}
      initial="hidden"
      animate={inView ? 'visible' : 'hidden'}
      variants={variants}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedSection;